<template>
  <div style="padding: 0 10px">
    <From @search="searchCall" />
    <WmsTable
      :columns="columns"
      :dataSource="dataSource"
      @pageChange="pageChangeCall" :isPagination="query" 
    >
     
      <div slot="image" slot-scope="{ record }">
        <ImgPreviews :images="[record.productImg]"></ImgPreviews>
        {{record.productName}}
      </div>
      <el-input
        slot="expressNoAction"
        slot-scope="{ text, record, index }"
        v-model="record.expressNo"
        @change="changeExpressNo(r)"
      ></el-input
      >z
      <a
        href="javascript:;"
        slot="action"
        slot-scope="{ text, record, index }"
        @click="receipt(record)"
        >签收</a
      >
    </WmsTable>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import From from "@/views/inventoryDetails/lost/components/From";
import ImgPreviews from "@/components/ImgPreviews";
import { columns } from "@/views/inventoryDetails/lost/indexData";
import { innerExceptionPage } from "@/apis/abnormal";

export default {
  title: "丢件列表",
  name: "Lost",
  components: {
    WmsTable,
    ImgPreviews,
    From,
  },
  data() {
    return {
      columns,
      query: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      dataSource: [],
    };
  },
  methods: {
    searchCall: function (fromData) {
      this.query.current = 1;
      this.query.total = 1;
      this.expressNo = fromData.expressNo || undefined;
      this.lossFlag = 1
      this.abnormalType = fromData.abnormalType || undefined;
      this.getDataSource();
    },
    pageChangeCall: function (payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource();
    },
    receipt: function (r) {
      this.$message.warning("开发中");
    },
    changeExpressNo: function (r) {
      this.$message.warning("开发中");
      this.getDataSource();
    },
    getDataSource: function () {
      let params = {
        // abnormalType: this.abnormalType,
        pageNum: this.query.current,
        pageSize: this.query.pageSize,
        expressNo: this.expressNo || undefined,
        lossFlag: this.lossFlag || undefined,
      };
      innerExceptionPage(params).then(({ code, data }) => {
        if (code === 0) {
          this.dataSource = data.records;
          this.query.total = data.total;
        }
      });
    },
  },
};
</script>

<style scoped></style>
